<template>
  <div>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200">
      <circle class="loading-obj" stroke-width="15" r="15" cx="40" cy="65">
        <animate
          attributeName="cy"
          calcMode="spline"
          :dur="duration"
          values="65;135;65;"
          keySplines=".5 0 .5 1;.5 0 .5 1"
          repeatCount="indefinite"
          begin="-.4"
        ></animate>
      </circle>
      <circle class="loading-obj" stroke-width="15" r="15" cx="100" cy="65">
        <animate
          attributeName="cy"
          calcMode="spline"
          :dur="duration"
          values="65;135;65;"
          keySplines=".5 0 .5 1;.5 0 .5 1"
          repeatCount="indefinite"
          begin="-.2"
        ></animate>
      </circle>
      <circle class="loading-obj" stroke-width="15" r="15" cx="160" cy="65">
        <animate
          attributeName="cy"
          calcMode="spline"
          :dur="duration"
          values="65;135;65;"
          keySplines=".5 0 .5 1;.5 0 .5 1"
          repeatCount="indefinite"
          begin="0"
        ></animate>
      </circle>
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    duration: {
      type: Number,
      default: 1.5
    }
  }
}
</script>

<style lang="scss" scoped>
.loading-obj {
  fill: var(--v-primary-base);
  stroke: var(--v-primary-base);
}
</style>
